import { Component } from "@angular/core";
import { MatIcon } from "@angular/material/icon";

@Component({
	selector: "app-topbar-language-selection",
	imports: [MatIcon],
	templateUrl: "./topbar-language-selection.component.html",
})
export class TopbarLanguageSelectionComponent {}
